// Duration Magnitudes, in seconds.
export const second = 1;
export const minute = 60 * second;
export const hour = 60 * minute;
export const day = 24 * hour;
export const week = 7 * day;
export const year = 365 * day;
export const month = year / 12;
